import { ReservationListReportRequestModel } from '../api/models/ReservationListReportRequestModel';
import { DateTypeEnum, ReservationListReportFormModel } from '../models';

export const dataFormToRequest = (
  data: ReservationListReportFormModel
): ReservationListReportRequestModel => {
  return {
    from: data.from,
    to: data.to,
    date_type: data.date_type,
    rate_ids: (data?.rates || []).map(item => Number(item)),
    room_type_id: data?.roomType && Number(data?.roomType) !== 0 ? data?.roomType : null,
    states: data?.states,
    card_id: data?.company?.id,
    file_type: data.file_type,
    ...(data?.date_type !== DateTypeEnum.CANCELLATION_DATE && {
      currency_id: data.currency ? Number(data.currency.id) : null,
      fixed_at: data?.fixed_at ? Number(data?.fixed_at) : null,
      gross_revenue: data?.gross_revenue,
      currency_application: data?.currency_application,
      with_revenue: data?.with_revenue,
    }),
  };
};
